import styled from "styled-components";

export const NavigatorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 0px 10px 20px;
    width: 100%;
`;

export const NavigatorLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 550px;
    padding-right: 50px;
    padding-bottom: 5px;
    box-sizing: border-box;
`;

export const NavigatorCenter = styled.div`
    display: flex;
    justify-content: center;
    flex: 1 1 auto;
    position: relative;
`;

export const NavigatorRight = styled.div`
    font-family: -apple-system, "SF UI Text", "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Source Han Sans CN", "Microsoft YaHei", "WenQuanYi Zen Hei", sans-serif;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 550px;
    margin-top: 5px;
    padding-left: 60px;
    padding-right: 20px;
    padding-bottom: 5px;
    box-sizing: border-box;
`;

export const ScreenTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ScreenTitleCn = styled.div`
    font-family: 优设标题黑;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 6px;
    color: #EFEFEF;
    background: linear-gradient(0deg, rgba(72, 93, 140, 1.0) 10%, rgba(255, 255, 255, 1.0) 30%);
    background-clip: text;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const ScreenTitleEn = styled.div`
    font-family: 优设标题黑;
    font-size: 12px;
    letter-spacing: 3px;
    margin-left: 5px;
    color: #EFEFEF;
    background: linear-gradient(0deg, rgba(72, 93, 140, 1.0) 10%, rgba(255, 255, 255, 1.0) 30%);
    background-clip: text;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const NavigateItems = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    padding: 0px 40px;
    position: relative;
    top: 1px;
`;

export const NavigateItemLeft = styled.a`
    position: relative;
    font-size: 16px;
    letter-spacing: 5px;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.5);
    padding: 10px 20px 10px 20px;
    margin: 0px 10px;
    cursor: pointer;
    transition: all 0.5s;
    text-decoration: none;
    text-align: center;
    background-image: url(static/images/big-screen/electric-wheel-concise/navigate-item-left-background.png);
    background-size: 100% 100%;

    &.selected {
        color: rgba(255, 255, 255, 0.95);
        text-shadow: 0px 0px 3px #FFFFFF;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.95);
        text-shadow: 0px 0px 5px #FFFFFF;
    }
`;

export const NavigateItemRight = styled.a`
    position: relative;
    font-size: 16px;
    letter-spacing: 5px;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.5);
    padding: 10px 20px 10px 20px;
    margin: 0px 10px;
    cursor: pointer;
    transition: all 0.5s;
    text-decoration: none;
    text-align: center;
    background-image: url(static/images/big-screen/electric-wheel-concise/navigate-item-right-background.png);
    background-size: 100% 100%;

    &.selected {
        color: rgba(255, 255, 255, 0.95);
        text-shadow: 0px 0px 3px #FFFFFF;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.95);
        text-shadow: 0px 0px 5px #FFFFFF;
    }
`;

export const NavigateItemSeparator = styled.div`
    height: 18px;
    width: 1px;
    margin-bottom: 10px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.25) 50%, rgba(255, 255, 255, 0.1) 100%);
`;

export const TitleBorder = styled.div`
    position: absolute;
    top: 25px;
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

export const BorderLeftCircle = styled.div`
    width: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.25);
    margin: 0px 5px 0px 0px;
`;

export const BorderLeftBlock = styled.div`
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.25);
`;

export const BorderLine = styled.div`
    flex: 1 1 auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: bottom;
`;

export const BorderRightLine = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    top: -10px;
    left: -1px;
    height: 20px;
    width: 200px;
    border-top: 1px solid rgba(255, 255, 255, 0.25);
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    transform: skew(-45deg);
    transform-origin: left bottom;
`;

export const BorderRightBlock = styled.div`
    position: relative;
    left: 18px;
    top: -20px;
    height: 3px;
    width: 30px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.25);
`;

export const BorderRightCircle = styled.div`
    position: relative;
    left: 18px;
    top: -20px;
    width: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0px 0px 0px 5px;
`;

export const Content = styled.div`
    flex: 1 1 auto;
`;


